import { TermlyPolicyPage } from '../components/legal/TermlyPolicyPage';

const TERMLY_POLICY_ID = 'e61ee500-018a-4c11-9fb6-39bced4171c9';

export function PrivacyPolicyPage() {
  return (
    <TermlyPolicyPage
      policyId={TERMLY_POLICY_ID}
      title="Privacy Policy"
      description="How we collect, use, and protect your data."
    />
  );
}
